import React from 'react';
import PropTypes from 'prop-types';

const MenuHeader = ({ itemName, parentItemName }) => {
    return (
      <div className="Screen-header">
        <div className="Screen-header-title">
        {parentItemName ? `${parentItemName} > ${itemName}`: `${itemName}`}
        </div>
      </div>
    )
}
  
MenuHeader.propTypes = {
    itemName: PropTypes.string,
    parentItemName: PropTypes.string,
}

export default MenuHeader;